import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=b59e086a&scoped=true&"
import script from "./BusinessType.vue?vue&type=script&lang=ts&"
export * from "./BusinessType.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessType.vue?vue&type=style&index=0&id=b59e086a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e086a",
  null
  
)

export default component.exports